export default __webpack_public_path__ + "static/media/logo-white.0f95efaf.svg";